<div class="sidebar-sticky d-flex justify-content-between" id="left-side-bar">
  <div class="nav-bar-left" >
    <div class="nav-item not-selectable" style="margin-bottom: 25%; margin-top: 20%;">
      <a class="nav-link" [routerLink]="''">
        <img class="navbar__logo" src="assets/icon/new_icon/logo-explore.svg" alt="Explore Logo" width="120"/>
      </a>
    </div>
    <div *showIfHasRole="['manage_user','manage_area','manage_site']" class="navbar-text d-inline-flex align-items-center justify-content-between not-selectable"  (click)="inverserReferentielOuvert()" style="padding-right:5px;">
      <div class="d-flex">{{'NAV_BAR_LEFT.REFERENTIEL' | translate }}</div>
      <div class="d-flex">
        @if (!referentielOuvert()) {
          <i class="fas fa-chevron-down"></i>
        }
        @if (referentielOuvert()) {
          <i class="fas fa-chevron-up"></i>
        }
      </div>
    </div>
    <div [ngClass]="referentielOuvert() ? 'display-div scrollable-menu': 'hidden-div'">
      <ul class="nav flex-column not-selectable">
        <li *showIfHasRole="'manage_user'"  [routerLinkActive]='["link-active"]' class="nav-item hoverable">
          <a class="nav-link" [routerLink]="'users'">
            <i class="fas fa-users fas-resize"></i>
            <span>{{'GLOBAL.UTILISATEURS' | translate }}</span>
          </a>
        </li>
        <li *showIfHasRole="'manage_site'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: true}" class="nav-item hoverable">
          <a class="nav-link" [routerLink]="'user-dashboard'">
            <i class="fas fa-magnifying-glass-chart fas-resize"></i>
            <span>{{'GLOBAL.USER_DASHBOARD' | translate }}</span>
          </a>
        </li>
        @if (enableSetupOrganization()) {
          <li [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: true}" class="nav-item hoverable">
            <a *showIfHasRole="'org_manager'" class="nav-link" [routerLink]="'setup-organization'">
              <i class="fas fa-building fas-resize"></i>
              <span>{{'GLOBAL.SETUP_ORGANIZATION' | translate }}</span>
            </a>
          </li>
        }
        <li *showIfHasRole="'manage_area'"  [routerLinkActive]='["link-active"]' class="nav-item hoverable">
          <a class="nav-link" [routerLink]="'regions'">
            <i class="fas fa-globe-americas fas-resize"></i>
            <span>{{'GLOBAL.REGIONS' | translate }}</span>
          </a>
        </li>
        <li *showIfHasRole="'org_manager'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: true}" class="nav-item hoverable">
          <a class="nav-link" [routerLink]="'area-dashboard'">
            <i class="fas fa-search-location fas-resize"></i>
            <span>{{'GLOBAL.AREA_DASHBOARD' | translate }}</span>
          </a>
        </li>
        <li *showIfHasRole="'manage_area'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: false}"  class="nav-item hoverable">
          @if (utilService.currentRegionForSetupRegion || utilService.regionsForProducts.length > 0) {
            <a class="nav-link" 
               [routerLink]="['/region-setup', (utilService.currentRegionForSetupRegion?.regionId ?? utilService.regionsForProducts[0]?.regionId ?? 0)]">
              <i class="fas fa-project-diagram fas-resize"></i>
              <span>{{'GLOBAL.REGION_SETUP' | translate }}</span>
            </a>
          }
        </li>
        <li *showIfHasRole="'manage_site'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: true}" class="nav-item hoverable">
          <a class="nav-link" [routerLink]="'sites'">
            <i class="far fa-map fas-resize"></i>
            <span>{{'GLOBAL.SITES' | translate }}</span>
          </a>
        </li>
        <li *showIfHasRole="'manage_site'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact: false}" class="nav-item hoverable">
          @if (utilService.currentSite() || utilService.listeSites.length > 0) {
            <a class="nav-link" 
               [routerLink]="['/site-setup', (utilService.currentSite()?.siteId ?? utilService.listeSites[0]?.siteId ?? 0)]">
              <i class="fas fa-map-marked-alt fas-resize"></i>
              <span>{{'GLOBAL.SITE_SETUP' | translate }}</span>
            </a>
          }
        </li>
      </ul>
    </div>
    
    <div *showIfHasRole="['manage_user','manage_area','manage_site']" class="navbar-text d-inline-flex align-items-center justify-content-between not-selectable"  (click)="inverserReferentielOuvert()" style="padding-right:5px;">
      <div class="d-flex">{{'NAV_BAR_LEFT.EXPLOITATION' | translate }}</div>
      <div class="d-flex">
        @if (referentielOuvert()) {
          <i class="fas fa-chevron-down"></i>
        }
        @if (!referentielOuvert()) {
          <i class="fas fa-chevron-up"></i>
        }
      </div>
    </div>
    <ul class="nav flex-column not-selectable" [ngClass]="!referentielOuvert() ? 'display-div-300': 'hidden-div'">
      <li *showIfHasRole="'explore_app_user'" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]="{exact:true}" class="nav-item hoverable">
        @if (utilService.currentSite() || utilService.listeSites.length > 0) {
          <a class="nav-link" 
             [routerLink]="['/mysite', (utilService.currentSite()?.siteId || utilService.listeSites[0]?.siteId)]">
            <i class="fas fa-home fas-resize"></i>
            <span>{{'NAV_BAR_LEFT.MON_SITE' | translate }}</span>
          </a>
        }
      </li>
      <li *showIfHasRole="'explore_app_user'" [ngClass]="router.url.includes('myprojects') ? 'link-active':''" class="nav-item hoverable">
        @if (utilService.currentSite() || utilService.listeSites.length > 0) {
          <a class="nav-link" 
             [routerLink]="['/mysite', (utilService.currentSite()?.siteId || utilService.listeSites[0]?.siteId), 'myprojects']">
            <i class="fas fa-suitcase fas-resize"></i>
            <span>{{'NAV_BAR_LEFT.MES_PROJETS' | translate }}</span>
          </a>
        }
      </li>
      <li *showIfHasRole="'explore_app_user'" [routerLinkActive]='["link-active"]' class="nav-item hoverable">
        @if (utilService.currentSite() || utilService.listeSites.length > 0) {
          <a class="nav-link" 
             [routerLink]="['/mysite', (utilService.currentSite()?.siteId || utilService.listeSites[0]?.siteId), 'operations']">
            <i class="fas fas-resize fa-chart-gantt"></i>
            <span>{{'NAV_BAR_LEFT.OPERATIONS' | translate }}</span>
          </a>
        }
      </li>
      <li *showIfHasRole="'explore_app_user'" [routerLinkActive]='["link-active"]' class="nav-item hoverable">
        @if (utilService.currentSite() || utilService.listeSites.length > 0) {
          <a class="nav-link" 
             [routerLink]="['/mysite', (utilService.currentSite()?.siteId || utilService.listeSites[0]?.siteId), 'dashboard']">
            <i class="fas fa-tachometer-alt fas-resize"></i>
            <span>{{'GLOBAL.DASHBOARD' | translate }}</span>
          </a>
        }
      </li>
    </ul>
  </div>
  <div class="d-flex align-items-end justify-content-center" style="width: 100%;">
    <b id="tenantId">{{tenantName()}}</b>
    <b id="version">{{versionNumber()}} </b>
  </div>
</div>
